<template>
  <section class="selftests">
    <div class="response_table">
      <table>
        <thead>
          <tr>
            <th scope="col"> ID </th>
            <th scope="col"> TS </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(elem_test, elem_test_key) in factorytest_list" :key="elem_test_key" @click="show_modal(elem_test)">
            <td data-label="ID" >
              {{elem_test.id}}
            </td>
            <td data-label="TS" >
              {{get_date(elem_test.ts)}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import SelfTestsModal from './SelfTestsModal.vue'

export default {
  name: 'FactoryTestList',
  props: ['device_id'],

  data(){
    return {
      factorytest_list:{},
    }
  },
  created() {
    this.init()
  },
  methods: {
    show_modal(data){
      var t = this.$createElement(SelfTestsModal, {
        props: {
          type: 'factorytest_list',
          data
        },
        on: {
          close: () => {this.$modal.hide('dynamic-modal') }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
    },
    init(){
      this.$http.v1.getDeviceFactoryList( {device_id: this.device_id}, (response) => {
        this.factorytest_list = response.data.factorytest_list
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  section.selftests{
    display: flex;
    .response_table{
      padding: 0;
      .title{
        text-align: center;
        margin-top: 10px;
      }
      tbody{
        tr{
          cursor: pointer;
          &:hover{
            background-color: #f1f1f1;
          }
        }
      }
    }
  }
</style>
